import type { RootState } from 'state';
import FetchingStatus from 'constants/statuses/FetchingStatus';

function getStaticRoutesFetching(state: RootState): boolean {
  const { fetching } = state.staticRoutes;

  return fetching === FetchingStatus.InProgress;
}

export default getStaticRoutesFetching;
